import React, {
  ReactElement,
} from 'react';
import Avatar from "@mui/material/Avatar";
import {Typography} from "@mui/material";

export const UserAvatar = ({
  user,
}: {
  user: any;
}): ReactElement => {

  return (
    <>
      <Avatar
        sx={{
          bgcolor: user?.avatar_color
            ? user?.avatar_color
            : '#678fff',
        }}
        src={user?.avatar?.link}
      >

          {user?.name? user.name.charAt(0).toUpperCase() : '-'}

      </Avatar>
    </>
  );
};
